var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-message",class:_vm.statusClass},[(_vm.alertType === 'error')?_c('img',{staticStyle:{"margin-bottom":"30px"},attrs:{"src":require("@components/assets/alert-icon-red.svg"),"alt":"Alert Icon"}}):_vm._e(),_c('div',{staticClass:"message-content"},[_c('span',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }